import type { BrazeOperatorContextType } from "./types";

export const defaultBrazeOperatorContext: BrazeOperatorContextType = {
  isOperatorSuppressed: false,
  // For justification for why this value is false see the FAQ in @lib/agenticAi/README.md
  isAgenticChangeEnabled: false,
  registerChangeTool: () => () => {},
};
